import debugTools from "../evaluation/debug";
import { ERROR_MESSAGES } from "../constants/errorMessages";

export default {
    /**
     *
     * @param {Object} feed the feed information retrieved from the ABBA dashboard API
     * @param {Object} bridge platform (web/mobile) specific logic module
     */
    verifyGetConfigArguments(feed) {
        if (!feed) {
            debugTools.error(ERROR_MESSAGES.NULL_FEED);

            throw new Error(ERROR_MESSAGES.NULL_FEED);
        } else if (!feed.targets) {
            debugTools.error(ERROR_MESSAGES.NULL_FEED_TARGETS);

            throw new Error(ERROR_MESSAGES.NULL_FEED_TARGETS);
        } else if (!Array.isArray(feed.targets)) {
            debugTools.error(ERROR_MESSAGES.FEED_TARGETS_NOT_ARRAY);

            throw new Error(ERROR_MESSAGES.FEED_TARGETS_NOT_ARRAY);
        } else if (feed.targets.length === 0) {
            debugTools.error(ERROR_MESSAGES.EMPTY_TARGETS);

            throw new Error(ERROR_MESSAGES.EMPTY_TARGETS);
        }

        return true;
    },
};
